import { FunctionComponent } from "react";
import { Box, Typography } from "@mui/material";
import { colorGrayDark, grayscaleBg } from "../../styles/theme";
import RelevancyToggle, { RelevancyValue } from "./RelevancyToggle";

interface Props {
	selectedValue: RelevancyValue | null;
	onChange: (value: RelevancyValue) => void;
}

const RelevancyPrompt: FunctionComponent<Props> = ({
	selectedValue,
	onChange,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				gap: "10px",
				padding: "10px 12px",
				borderRadius: "16px",
				backgroundColor: grayscaleBg,
			}}
		>
			<Typography
				sx={{ fontSize: "14px", lineHeight: "20px", color: colorGrayDark }}
			>
				Was this article relevant to you?
			</Typography>
			<RelevancyToggle
				variant="round"
				selectedValue={selectedValue}
				onChange={onChange}
			/>
		</Box>
	);
};

export default RelevancyPrompt;
